var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_60",
    "data-name": "Mask Group 60",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(253.714 9.071)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M4.5,5.143H7.714V6.429H4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M4.5,7.714H7.714V9H4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M4.5,10.286H7.714v1.286H4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M12.857,5.143h3.214V6.429H12.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M12.857,7.714h3.214V9H12.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M12.857,10.286h3.214v1.286H12.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M18,2.571H2.571A1.287,1.287,0,0,0,1.286,3.857V18a1.287,1.287,0,0,0,1.286,1.286H18A1.287,1.287,0,0,0,19.286,18V3.857A1.287,1.287,0,0,0,18,2.571ZM2.571,3.857H9.643V18H2.571ZM10.929,18V3.857H18V18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.fba8bd272cfc621c26efc126c2ff261f.svg";
export { ForwardRef as ReactComponent };